import script from "./RacePoints.vue?vue&type=script&setup=true&lang=ts"
export * from "./RacePoints.vue?vue&type=script&setup=true&lang=ts"

import "./RacePoints.vue?vue&type=style&index=0&id=3ee34fdf&lang=css"

const __exports__ = script;

export default __exports__